<template>
  <div class="container home-container">

    <van-nav-bar class="nav-bar" v-if="false">
      <template #left>
          <img style="width: 8.9375rem;" v-if="$store.getters.getBaseInfo.ico" :src="$store.getters.getBaseInfo.ico">
      </template>
      <template #right>
        <img @click="service" style="width: 30px;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAI9SURBVHgB7ZjdccIwDIAVjvdmA9wNYINsUDYgnQA6AWwAG4ROQDtBugHtBKETwAaq1OgoOHb+bEIe+t3pWhJZkmXHsh2AJxAxpD+h/DwFQXCCe8IBkSxIUpIjmuF3a5IIuoKcjcVxUzKSGG6FZGyN7mQkqq7foI6SGNyRjC0qnyLf8ntEokQ/NOjz/HymefoGrnBw0mtTJngOhhXtY5K9JZszcEGGNdOM8gexgIZIZ44GW2NoCzVODFlrbdAyGlnVKNiMxYbeKnDEEuQammIwEoMnyFaERVQTA3r2EvAM2dxoPlZ1G/IQpFrjKXgG8wVfn0JhWYMI7RUiQ5evrehriXaSwnDTgxlWswFPoHld1ROiWHcg/9Rx/gDdoUh+5/2AJAZzObo3POUiDvAJ+suMA/Q2+W/AdAD9Jux7gPAfoCutA6QlYC6VR5XozETHac9Xl0Rrl16s+rH2jje6S1sVwupKcoaV9zV19QC52F/ukI8S9F57nqGWZawf4J6H+B1aQAcePiRNSA7yiKtRBNcHJT4UTUj3AO14HUJeh/nwoqAh4vgR84M5y0hefZF8SCfacoC8g+fhqkp7l7uZ4mEK843qtqSBAk+QrV2Jn6TSlwR7Kd52O3j9dWeYj553P22Dm2oZi6EvYHFZWkGXYH4STDC/YFLau7mWOW8fXN3gTLdeC/y7P7xkC12C5kO4jRU0ZAjuRBXv+aqNF+wXx4W7HVi8hdCH+e5Lh+mKjkmhL2DxxipFj5XHG3iDavADf6qIoLNv5gYAAAAASUVORK5CYII=">
      </template>
    </van-nav-bar>


    <div class="home-scroll">

      <div class="header-card">
        <!-- Logo -->
        <div class="logo-area">
          <div class="logo-text">
            <img  :src="this.$store.getters.getBaseInfo.ico !==undefined ?this.$store.getters.getBaseInfo.ico:'/img/null.png'">
          </div>
        </div>

        <!-- 用户信息与ID -->
        <div class="user-row">
          <div class="avatar">
            <img  :src="this.$store.getters.getBaseInfo.ico !==undefined ?this.$store.getters.getBaseInfo.ico:'/img/null.png'">
          </div>
          <div class="user-details">
            <div class="user-name">
              {{ userInfo.username }}
              <span class="user-id">ID: {{ userInfo.id }}</span>
            </div>

            <!-- 余额展示 -->
            <div class="balance-section">
              <div class="balance-amount">{{ eye == 1?formatNumber(userInfo.money):"***" }}{{ this.$store.getters.getBaseInfo.currency }}</div>
              <div class="balance-label" @click="eyeFun()">
                <div class="eyeIcon">
                  <img v-if="eye == 1" alt="" class="icon" src="/img/home/eye.png"/>
                  <img v-if="eye == 2" class="icon" src="/img/home/eye-off.png">
                </div>
                {{ $t("账户余额") }}
              </div>
            </div>
          </div>
        </div>
      </div>

        <!-- 充值与提现按钮 -->
        <div class="action-bar">
          <div class="action-btn" @click="getFun('Recharge')">
            <img alt="" class="icon"  src="/img/home/recharge.png"/>{{ $t("存款") }}
          </div>
          <div class="action-btn" @click="doWithdrawal">
            <img alt="" class="icon" src="/img/home/withdraw.png"/> {{ $t("提款") }}
          </div>
        </div>

      <div class="banner">
        <swiper class="banner_swiper" :options="bannerSwiperOption">
          <swiper-slide v-for="(v,key) in banners" :key="key">
            <van-image class="banner_img" round :src="v.url">
              <template v-slot:loading>
                <van-loading type="circular"/>
              </template>
            </van-image>
          </swiper-slide>
        </swiper>
      </div>
      <div class="notice-bar">
        <van-notice-bar  v-if="this.notice"
            class="notice-swipe"
            left-icon="bullhorn-o"
            background="#ffffff"
            color="#7e5678"
            :text="this.notice"
        />
        <div class="linear-gradient"></div>
      </div>
      <div class="order_no_ipt">
        <img class="searchImg" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQhSURBVHgB1ZjNbtNYFMfPuU5QmQ8N0sysmNGY1fRjRjWlRWg2ZHazm74BaTr7Mk9A5gkmXdNS8wbtE+BuEJBINQLSIhaYBQghFkFIVUXjezjXJDfXrh2S1onKf+X7Yd+fz7XPOfcAnHIh5KCpP5Z/Mdu7d9dfQE46FuDkwtJVJFzk2x0EcgDxXMo0HyT5gLTZbGxswTE1FODkpaVriKKMCKVh7iOgACV4JLG6uzOcdQcCjCwGosaTndSHELQIqWX02JABKgFrT+vrq5AX4PR85QZvYRUSQBLRLUjafv9t6AWe20re99v8PyUJ8irfW+ambY4RgQchlAexZl/A6UuVDRDRAhqMrVDb/0aupkFlaeby8jWGqpqgyprQxtLnIDMBp+Yr/yPidWOiJ4v81if4Q5O7MQgkDvQgotpu49a/kIOm55f+BhAur9z98/39w/DPwE/fEZHsmHTKtgkniap5wSkpl2OhXDS6nLMFcSNrvpXs+PHnuR2ET35NbSvDLUHOevPKf/HD+bkWP/+vaB3EK9+fd7y33J+cG7Ng5OcA7U4zUN8cjEi77GqUAbptJFFNmxcDRBHbWjfPkJWm0Ar17ijnr/wtZAH+HjljtKMGuxM8gy6MWHv33CBuRVyELEBpDiJsjtp6PQBZ1csiZAPyaC+MEW7CmPSovrGtdqwDYSczIw3Inl4D7rfb2zBGseV8ff0BY/E+AnSc8jntOPltspzmqETsMfQ1kg1JwIMJ6OVzsaxkTCIOeXp5iuWWAk65TgUguxptNUKM7WAEqPyRMd221Tc5RhGvqVcnDMwxw4K972CiiLMwRvGPof/cQ2zH/K8BiJ5xRwnGpOmFsmNGsGd11zfHNaAF0tWdOLok4YikWNHXHMGSwz3AQ3poevS0wJ23VO5JwjghpkQwDehHzplqvQFRgxFLFEQsvWs21rYyAZXOtOVqz4rgqHMJjEjJzJ3DXTVtXiyjfv3aP+BM9yCW6f40F7x9ufMQcobDorjTzdxBWa++npq5H3HUyUxXSKjl+T0acLZqR0fZYnalIjWSdDLdIGpwEsHfo/frwvIKnFAzFyuzJpwSWdj3KJt5Lp68UrZFaN0BsyogyT1OfUVFpomCWBGJCoVkd3bwIdw6+5X1XRZk38pCKmQHVApy91Sy2UczlyuzoYRF3qbrZgUs2la2XPP+2tbUQuW5sqg63u41bv03FGBXafWZSERcCkGf/8CgmzJRFPjRxih8oZ2yoK5QdAzwHPR7H4UcuPzWeZg6YJfheAqUK3nyYP222Zl8+STk0AVMA7QEya1P6FNZDjYF4e3HjTUva14/yBOVgBVsoV1gh0uzspMJ84/QkiG9A8vym/Wb/qDPOlIPKoKtPoNcatR5yYBUjvuC6jtVKX+Tt1VaxQv7X4cX4UvRRxmnyQl6OS0QAAAAAElFTkSuQmCC" />

        <div class="u-input" style="padding: 0px; border-color: rgb(223, 232, 246); text-align: left;width: 65%">
          <van-field v-model="search"  clearable  class="input"  style="border-color: rgb(223, 232, 246);" :placeholder="$t('查找项目或项目代码')" />
        </div>
        <div class="checkBtn" @click="searchFun()">{{ $t("搜索") }}</div>
      </div>


      <div class="hot-game area" style="margin-top: 10px" >

        <div class="hot-items-div" v-if="false">>
          <van-grid :border=false :column-num="4" :icon-size="20">
            <van-grid-item @click="getFun('Game')">
              <van-image class="game_item_img" src="/img/home/tab1.png">
                <template v-slot:loading>
                  <van-loading type="circular"/>
                </template>
              </van-image>
              <span style="margin-bottom: 10px">{{ $t("流行的") }}</span>
            </van-grid-item>

            <van-grid-item  @click="getFun('GameRecord')">
              <van-image class="game_item_img" src="/img/home/tab3.png">
                <template v-slot:loading>
                  <van-loading type="circular"/>
                </template>
              </van-image>
              <span style="margin-bottom: 10px">{{ $t("历史") }}</span>
            </van-grid-item>
            <van-grid-item @click="getFun('Recharge')">
              <van-image class="game_item_img" src="/img/home/tab4.png">
                <template v-slot:loading>
                  <van-loading type="circular"/>
                </template>
              </van-image>
              <span style="margin-bottom: 10px">{{ $t("存款") }}</span>
            </van-grid-item>
            <van-grid-item @click="doWithdrawal">
              <van-image class="game_item_img" src="/img/home/tab5.png">
                <template v-slot:loading>
                  <van-loading type="circular"/>
                </template>
              </van-image>
              <span style="margin-bottom: 10px">{{ $t("提款") }}</span>
            </van-grid-item>

          </van-grid>
        </div>
        <div >

          <div class="title u-flex u-font-32 font-bold mb-[32rpx]">
            <img class="mr-[8rpx] w-[40rpx] h-[40rpx]" src="data:image/png;base64,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" />
            <div style="color: rgb(48, 142, 227);">{{ $t("项目列表") }}</div>
          </div>
        </div>
        <div class="brands" style="margin: 10px 0 100px 0">
          <div class="item" v-for="(item,key) in gameitem"  @click="toLottery(item.key,item.id)"  :key="key">
            <img class="mr-[16rpx] w-[80rpx] h-[80rpx]"  style="    border-radius: 50%;" :src="item.ico" />
            <div style="width: 100%">
              <div class="name u-font-28 u-line-1 mb-[12rpx]">{{item.name}}</div>
              <div class="frequency u-font-24">{{item.desc}}</div>
            </div>
            <div class="project-right">
              <img alt="" class="icon"  src="/img/home/heart.png"/>
              <div class="countdown-box">
                <span class="countdown-label">{{ $t("稍后结束") }}</span>

                <span class="countdown-time">
                    {{ secondsToMinutesSecondsShort(item.second) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      eye: 1,
      search: "",
      userInfo:{},
      notice: this.$t("msg.获取中"),
      banners: [{}],
      basicData: [],
      gameitem: [],
      movielist_0: [],
      movielist_1: [],
      isLoading: false,
      gameitem1:{},
      movielistSwiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed: 800,
        autoplay: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      }
    };
  },
  methods: {
    ruleFun(rule){
     return rule < 10?"0"+rule:rule;
    },
    eyeFun(){
      this.eye = this.eye == 1?2:1;
      localStorage.setItem('eye',this.eye)
    },
    doWithdrawal(){
      if(!this.userInfo.paypassword){
        this.$router.push("SetPayPassword");
        this.$toast(this.$t("setPayPassword.title"));
        return false;
      }

      this.$http({
        method: 'get',
        url: 'user_get_bank',
      }).then(res=>{
        if(res.data.is_bank){
          this.$router.push("withdraw");
        }else {
          this.$router.push("Setbank");
          this.$toast(this.$t("msg.请设置收款卡!"));
        }
      })
    },
    getFun(g){
      this.$router.push({path: '/'+g})
    },
    //客服
    service() {
      window.location.href = this.$store.getters.getBaseInfo.kefu;
    },
    gotoMenu(router) {
      this.$router.replace(router)
    },
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'})
      } else {
        this.$router.push({path: '/Lottery?key=' + key + "&id=" + id})
      }

    },
    toPlayVideo(id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'})
      } else {
        this.$router.push({path: '/nHomeDetail?id=' + id})
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.getBasicConfig();
        this.isLoading = false;
        this.$toast(this.$t("msg.刷新成功！"));
      }, 500);
    },
    getBasicConfig() {
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then(res => {
        this.basicData = res.data;
        this.getNotice(this.basicData);//获取公告
        this.getBanner(this.basicData);//获取banner
        this.getGameItem();//获取首页游戏列表
        this.getMovieList_0(this.basicData);//获取首页视频0
      })

    },
    getNotice(data) {
      this.notice = data.notice;
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_hot'
      }).then(res => {
        this.gameitem = res.data;
        this.gameitem1 = res.data;
        this.gameitem.forEach((time, index) => {
          this.startCountdown(index);
        });
      })
    },
   secondsToMinutesSecondsShort(seconds) {
      const minutes = Math.floor(seconds / 60);
      const seconds1 = seconds % 60;
      const minutes1 = minutes > 9? minutes:"0"+minutes;
      const seconds2 = seconds1 > 9? seconds1:"0"+seconds1;
      return `${minutes1}:${seconds2}`;
    },
    startCountdown(index) {
      const interval = setInterval(() => {
        if (this.gameitem[index].second > 0) {
          this.gameitem[index].second--;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
    searchFun(){
      this.gameitem = {};
      return this.gameitem = this.gameitem1.filter(item => item.name.includes(this.search)); // 假设数据中有一个name字段需要被搜索
    },
    getMovieList_0(data) {
      this.movielist_0 = data.movielist_0
    },
    getBanner(data) {
      this.banners = data.banners;
    },
     getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.menu_top = 15;
          if(this.userInfo.status !== 1){
            this.$toast(this.$t("msg.账号下线"));
            localStorage.clear()
            this.$router.push({path:'/Login'})
          }
        }else if(res.code ===401){
          this.$toast(this.$t(res.msg));
        }
      })
    },
  },
  mounted() {

  },
  created() {
    this.getUserInfo();
    this.getBasicConfig();
    var eye = localStorage.getItem('eye');
    var that = this;
    if(eye != null){
      that.eye = eye;
    }

  }
}

</script>

<style lang='less' scoped>
/* 右侧倒计时与收藏 */
.project-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  min-width: 65PX;
}

.heart-icon {
  font-size: 18PX;
  color: #ccc;
  cursor: pointer;
}
.heart-icon.active {
  color: #e60012;
}

.countdown-box {
  text-align: right;
}

.countdown-label {
  font-size: 11PX;
  color: #888;
  display: block;
  margin-bottom: 2PX;
}

.countdown-time {
  font-size: 20PX;
  font-weight: 700;
  color: #e60012;
  font-variant-numeric: tabular-nums; /* 等宽数字，防止跳动 */
}
.icon{
  width: 15PX;
  margin-right: 5PX;
}
.area .brands {
  display: flex;
  flex-direction: column
}

.area .brands .item {
  width: 100%;
  height: 150px;
  background: linear-gradient(180deg,#EBCBFE 0%,#F3ECF6 100%);
  border-radius: .5rem;
  display: flex;
  align-items: center;
  margin-bottom: .625rem;
  padding: .625rem
}

.area .brands .item:nth-child(5n+1) {
  background: linear-gradient(180deg,#EBCBFE 0%,#F3ECF6 100%)
}

.area .brands .item:nth-child(5n+2) {
  background: linear-gradient(180deg,#F7F5CB 0%,#F6F5EB 100%)
}

.area .brands .item:nth-child(5n+3) {
  background: linear-gradient(180deg,#DDF7CB 0%,#EEF5E7 100%)
}

.area .brands .item:nth-child(5n+4) {
  background: linear-gradient(180deg,#CBE6FA 0%,#E0F2FB 100%)
}

.area .brands .item:nth-child(5n+5) {
  background: linear-gradient(180deg,#FDCFD6 0%,#F5EFF0 100%)
}

.area .brands .item:nth-last-child(1) {
  margin-bottom: 0
}

.area .brands .item .name {
  color: #2a3563
}

.area .brands .item .frequency {
  color: #848fac
}
.w-\[80rpx\] {
  width: 80px;
}

.h-\[80rpx\] {
  height: 80px;
}
.mr-\[16rpx\] {
  margin-right: .5rem;
}
.u-font-28 {
  font-size: 28px;
}
.mb-\[12rpx\] {
  margin-bottom: .375rem;
}
.u-font-24 {
  font-size: 24px;
}

.w-\[40rpx\] {
  width: 1.25rem;
}
.h-\[40rpx\] {
  height: 1.25rem;
}
.mr-\[8rpx\] {
  margin-right: .25rem;
}
.u-font-32 {
  font-size: 1rem;
}
.u-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.font-bold {
  font-weight: 700;
}
.area{
  margin: 0 50px 20px;
}
.van-cell{
  height: auto;
  padding:0 20px ;
}
.order_no_ipt {
  position: relative;
  margin: 20px 50px;
  padding-left: 10px;
  border: 1px solid #dfe8f6;
  height: 50PX;
  display: flex;
  align-items: center;
  border-radius: .5rem;
  background-color: #fff;
}
.order_no_ipt .searchImg {
  width: 1.25rem;
  height: 1.25rem;
}
.order_no_ipt .checkBtn{
  display: flex;
  align-items: center;
  height: 80px;
  text-align: center;
  border: 1px solid #308ee3;
  border-radius: .25rem;
  background: #dfe8f6;
  color: #308ee3;
  font-size: 32px;
  width: 200px;
  justify-content: center;
  margin-right: 20px;
}
.movie_list_n {
  display: flex;
  flex-wrap: wrap;
  margin: 1.333vw;
  padding-bottom: 16vw;
}

.movie-list-n-item {
  width: calc(50% - 1.467vw);
  background-color: #fff;
  border: 1px solid #fff;
  color: #000;
  margin: 2.667vw .667vw;
  border-radius: 2.667vw;
  padding: 1.333vw;
}

.movie-list-n-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2.667vw;
  font-weight: 700;
}

.movie-list-n-img {
  width: 44vw;
  height: 44vw;
  position: relative;
  border-radius: 10px;
}

.movie-list-n-lab {
  display: inline;
  position: absolute;
  top: 2vw;
  left: 2vw;
  padding: .2em .6em .3em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .25em;
  background-color: #f905e5;
  width: 42vw;
  overflow: hidden;
}

.movie-n-time-div {
  margin-top: 2.667vw;
}

.movie-list-ico-loves {
  display: inline-block;
  width: 5.333vw;
}

.movie-list-notice {
  display: flex;
  align-items: center;
  margin-top: 1.333vw;
}

.movie-list-ico-notice {
  width: 4vw;
  display: inline-block;
  margin-right: 1.333vw;
}

.movie-list-addr {
  display: flex;
  align-items: center;
  margin-top: 1.333vw;
}

.movie-list-ico-addr {
  width: 4vw;
  display: inline-block;
  margin-right: 1.333vw;
}

.movie-list-money {
  display: flex;
  align-items: center;
  margin-top: 1.333vw;
}

.movie-list-ico-money {
  width: 4vw;
  display: inline-block;
  margin-right: 1.333vw;
}


@notice-bar-size: 30px;
@movie-list-item-bottom-size: 25px;
.linear-bg {
  height: 200px;
  background: linear-gradient(270deg, #c24491, #775fd9);
}

.home-container {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #ffffff;
}

.linear-gradient {
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));
}

::v-deep .van-notice-bar__left-icon, .van-notice-bar__right-icon {
  min-width: 40px;
}

.notice-swipe {
  width: calc(100% - 50px);
  height: 85px;
  font-size: @notice-bar-size;
}

::v-deep .van-icon-bullhorn-o::before {
  transform: scale(2.5);
}

.banner {
  width: 100%;
  margin-top: 20px
}

.banner_swiper {
  height: 300px;
  margin:0 16PX ;
  .swiper-slide {
    width: 100%;
  }
  /*.swiper-slide {
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 620px;
    height: 300px;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    background-color: #ffffff;
    background-position: center;
    background-size: cover;
    color: #ffffff;
  }*/
}

::v-deep .swiper-container-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
}

::v-deep .swiper-container-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
}

.banner_img {
  border-radius: 10px;
  width: 100%;
  height: 100%;
}

.hot-game {
  height: 100%;
}

.hot-title-div {
  width: calc(100% - 50px);
  margin: 0 auto;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hot-title-div > div:first-child {
  /*width: 130px;*/
}

.hot-title-div div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.hot-title-div > div:nth-child(2) span {
  font-size: 20px;
  color: #979799;
}

.hot-title-div > div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 10px;
  font-weight: 700;
  color: #000;
}

.hot-title-div > div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 28px;
  font-weight: 700;
  color: #000;
}

.hot-title-div > div:nth-child(2) span {
  font-size: 25px;
  color: #979799;
}

.hot-title-div > div:first-child span:before {
  content: "";
  display: block;
  width: 5px;
  height: 30px;
  background-color: #7e5678;
  border-radius: 1px;
  margin-right: 5px;
}

.hot-game .hot-items-div {
  margin-top: -3px;
}

.hot-game .hot-items-div span {
  margin-top: 10px;
  font-size: 22px;
  color: #000;
}

.hot-recommend {
  width: 100%;
  flex: 1;
  background-color: #f2f2f5;
}

.movie_swiper {
  .swiper-slide {
    width: 80%;
  }
}

.movie_list_0 {
  width: calc(100% - 50px);
  margin: 0 auto;
}

.movie_cover {
  border-radius: 10px;
  width: 550px;
  height: 330px
}

.movie_list_0 .movie-list-item-bottom {
  position: relative;
  width: 550px;
  bottom: 43px;
}

.movie_list_0 .movie-list-item-bottom .movie-time-div {
  background-color: rgba(0, 0, 0, .4);
}

.movie_list_0 .movie-list-item-bottom > div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie_list_0 .movie-list-item-bottom .movie-time-div .van-count-down {
  font-size: 28px;
  color: #fff;
}

.movie_list_0 .movie-time-div {
  color: #fff;
  border-radius: 0 0 10px 10px;
}

.movie_list_0 .movie_swiper .hot {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 80px;
}

.movie_list_0 span {
  font-size: 30px;
}

.movie_list_1 {
  display: flex;
  width: calc(100% - 50px);
  margin: 0 auto;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.movie_list_1 .movie-list-item .cover_img {
  border-radius: 10px;
  width: 335px;
  height: 290px;
}


.movie_list_1 .movie-list-item {
  margin-bottom: -10px;
}

.movie_list_1 .movie-list-item-bottom {
  position: relative;
  width: 335px;
  bottom: 42px;

}

.movie_list_1 .movie-list-item:nth-child(odd) {
  margin-right: 25px;
}

.movie_list_1 .movie-list-item-bottom .movie-time-div {
  background-color: rgba(0, 0, 0, .4);
}

.movie_list_1 .movie-list-item-bottom > div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.movie_list_1 .movie-list-item-bottom .movie-time-div .van-count-down {
  color: #fff;
}

.movie_list_1 .movie-time-div {
  color: #fff;
  border-radius: 0 0 10px 10px;
  height: 35px;
}

.movie_list_1 .movie_swiper .hot {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 5px;
}

.movie_list_1 .movie-list-item .movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 180px;
  padding-left: 8px;
  font-size: 25px;
}

.movie_list_1 .movie-list-item .movie-time-div span:last-child {
  overflow: hidden;
  white-space: nowrap;
  width: 0px;
  padding-right: 110px;
  font-size: 22px;
}

.movie_list_0 .movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 350px;
  padding-left: 10px;
  font-size: 25px;
}

.hot-recommend-more {
  width: 100%;
  padding-bottom: 20px;
  text-align: center;
  color: #979799;
  font-size: 30px;
}

.hot-items-div .game_item_img {
  width: 100px;
  height: 100px;
}

::v-deep .hot-items-div .game_item_img .van-image__img {
  border-radius: 20px;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}
.home-scroll{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 100px;
  margin-bottom: 100px;
  margin-top: 10PX;
}

.van-cell{
  font-size: 32px;
}
/* 红色头部卡片 */
.header-card {
  background: linear-gradient(135deg, #e60012 0%, #c2000f 100%);
  border-radius: 20PX;
  padding: 20PX;
  color: #fff;
  position: relative;
  overflow: hidden;
  /* 添加微妙的光影效果 */
  box-shadow: 0 4PX 15PX rgba(230, 0, 18, 0.3);
  margin: 0 16PX;

}

/* 背景装饰圆圈 */
.header-card::after {
  content: '';
  position: absolute;
  top: -30PX;
  right: -30PX;
  width: 120PX;
  height: 120PX;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

/* 顶部用户信息行 */
.user-row {
  display: flex;
  align-items: center;
}

/* 用户头像 */
.avatar {
  width: 45PX;
  height: 45PX;
  background-color: #ffb300;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20PX;
  font-weight: bold;
  margin-right: 12PX;
  border: 2PX solid rgba(255, 255, 255, 0.5);
}

.avatar img{
  border-radius: 50%;
  width: 100%;
}
/* 用户名与ID */
.user-details {
  flex: 1;
}

.user-name {
  font-size: 16PX;
  font-weight: 600;
  margin-bottom: 4PX;
  display: flex;
  align-items: center;
  margin-left: -20PX;
}

.user-id {
  background: rgba(0, 0, 0, 0.2);
  padding: 2PX 8PX;
  border-radius: 10PX;
  font-size: 12PX;
  font-weight: normal;
  margin-left: 2PX;
}

/* Logo区域 */
.logo-area {
  position: absolute;
  top: 40PX;
  right: 0PX;
  text-align: right;
}

.logo-area img {
  height: 32PX;
  margin-right: 8PX;
}
.logo-text {
  font-size: 22PX;
  font-weight: bold;
  letter-spacing: 1PX;
}

.logo-icon {
  font-size: 14PX;
  opacity: 0.9;
}

/* 余额区域 */
.balance-section {
  margin-bottom: 10PX;
}

.balance-amount {
  font-size: 28PX;
  font-weight: bold;
  margin-bottom: 5PX;
  letter-spacing: 0.5PX;
}

.balance-label {
  font-size: 13PX;
  opacity: 0.9;
  display: flex;
  align-items: center;
}

.balance-label i {
  margin-right: 5PX;
  font-size: 11PX;
}

/* 底部操作按钮卡片 */
.action-bar {
  display: flex;
  margin: 0 16PX;
  margin-top: -20PX;
  position: relative;
  justify-content: space-around;
}

.action-btn {
  background: #fff;
  border-radius: 12PX;
  padding: 12PX 15PX;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  font-size: 14PX;
  font-weight: 600;
  box-shadow: 0 2PX 8PX rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.1s;
}

.action-btn:active {
  transform: scale(0.98);
}

.action-btn i {
  font-size: 18PX;
  margin-right: 8PX;
}

.btn-nap { color: #e60012; } /* 充值按钮图标颜色 */
.btn-rut { color: #e60012; } /* 提现按钮图标颜色 */


.eyeIcon {
  margin-right: .5rem;
  width: 1.25rem;
  height: 1.25rem
}

.eyeIcon img {
  width: 1.25rem;
  height: 1.25rem
}
::v-deep van-icon{
  font-size: 18PX;
}
</style>
